export default "__VITE_ASSET__DGaLkHFl__"